import { Controller } from "@hotwired/stimulus"

// Copies the selected option's consensus number (its data-number attribute,
// rendered server-side from the snapshot the form was built at) into the
// line's number field. A number the admin has typed is never overwritten:
// the field is filled only while it is empty or still holds the value this
// controller last auto-filled. A server-prefilled edit value was not
// auto-filled in this session, so changing the select on an edit form leaves
// it alone until the admin clears it.
export default class extends Controller {
  static targets = ["select", "number"]

  connect() {
    this.lastAutofilled = null
  }

  fill() {
    const option = this.selectTarget.selectedOptions[0]
    const number = option ? (option.dataset.number ?? "") : ""
    const field = this.numberTarget

    if (field.value === "" || field.value === this.lastAutofilled) {
      field.value = number
      this.lastAutofilled = number
    }
  }
}
